import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from '@mui/material';
import RepeatIcon from '@mui/icons-material/Repeat';
import { useDispatch } from 'react-redux';
import { openOrderWindow } from '../../store/actions/orders';
import { mapOrderWindowData } from '../../services/utilities';
const OrderDetailsDialog = ({
  order,
  onClose,
  isMobile,
  detailFields,
  formatTime,
  showRejectionReason = true,
  showRepeatButton = false,
  titleConfig = {
    leftContent: (order) => (
      <>
        {order.trading_symbol}
        <Typography
          component="span"
          variant="caption"
          color="text.secondary"
          sx={{ ml: 0.5 }}
        >
          ({order.order_side}, {order.exchange})
        </Typography>
      </>
    ),

    rightContent: (order) => `${order.trade_quantity || order.filled_quantity}/${order.quantity || order.trade_quantity}`
  }
}) => {
  const dispatch = useDispatch();

  const handleRepeatClick = () => {
    // Normalize order type and determine price
    const normalizedOrderType =
      order.order_type === 'SLM' ? 'STOPLOSSMARKET' : order.order_type;

    let price, triggerPrice;
    switch (order.order_type) {
      case 'SLM':
        price = 0;  // Always 0 for SLM
        triggerPrice = order.trigger_price || order.price || order.trade_price || order.ltp || 0;
        break;
      case 'SL':
        price = order.price || order.trade_price || order.ltp || 0;
        triggerPrice = order.trigger_price || order.price || order.trade_price || order.ltp || 0;
        break;
      case 'LIMIT':
        price = order.price || order.trade_price || order.ltp || 0;
        triggerPrice = 0;
        break;
      default:
        price = order.price || order.trade_price || order.ltp || 0;
        triggerPrice = 0;
    }

    const repeatData = {
      ...order,
      price: price,
      trigger_price: triggerPrice,
      order_type: normalizedOrderType,
      is_repeat: true,
      quantity: order.trade_quantity || order.quantity || 1
    };

    console.log("Repeat Data payload:", repeatData);

    dispatch(openOrderWindow(mapOrderWindowData(repeatData, order.order_side)));
    if (onClose) onClose();
  };

  if (!order) return null;
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '400px'
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          borderBottom: '3px solid',
          borderColor: order.order_side === 'BUY' ? 'success.main' : 'error.main'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <Typography>
            {titleConfig.leftContent(order)}
          </Typography>
          <Typography>
            {titleConfig.rightContent(order)}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 2
        }}>
          {detailFields.map((field, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
            >
              <Typography>{field.value}</Typography>
              <Typography variant="caption" color="text.secondary">
                {field.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>

      {showRejectionReason && order.rejection_reason && order.rejection_reason !== 'NONE' && (
        <Box sx={{
          mt: 3,
          mx: 2,
          mb: 3
        }}>
          <Typography
            variant="body2"
            sx={{
              p: 1.5,
              backgroundColor: 'rgb(229, 246, 253)',
              color: 'rgb(1, 67, 97)',
              borderRadius: 1,
              fontWeight: 500
            }}
          >
            Rejection Reason: {order.rejection_reason}
          </Typography>
        </Box>
      )}

      <Box sx={{
        p: 2,
        borderTop: 1,
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1
      }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
        {showRepeatButton && (
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleRepeatClick}
            startIcon={<RepeatIcon />}
          >
            Repeat
          </Button>
        )}
      </Box>
    </Dialog>
  );
};

export default OrderDetailsDialog; 